import { Component, Input } from '@angular/core';   // , Output, EventEmitter
import type { TCampaignIncentive } from '@shared/models';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@Component({
    'selector': 'incentiveFormatBase',
    'styleUrls': ['./incentiveFormatBase.component.scss'],
    'template': '',
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class IncentiveFormatBaseComponent {
    // @Output() select = new EventEmitter();
    @Input() public incentives: TCampaignIncentive[] = [];
    public heading = 'Incentives';
}
